import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { first, Observable, skipWhile } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { State, select$ } from '@app/shared/helpers/store';
import { IUser } from '@app/models/user.interface'
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { selectMeState } from '@app/core/store/core.selectors';

@Injectable({
  providedIn: 'root'
})
export class UserLimitService {
  public endpoint: string = environment.apiUrl;
  public currentLimitData$: Observable<any>;

  constructor(private _http: HttpClient, private store$: Store) {

  }

  async onGetUserLimitStatus(type) {
    return new Promise((resolve) => {
      this.store$.select(selectMeState).pipe(
        skipWhile(res => res == null),
      ).subscribe(({ settingQtyLimiter, settingQtyCurrent }) => {
        if (type == 'users') {
          if (settingQtyLimiter.users > settingQtyCurrent.user_count || settingQtyLimiter.users == 0) {
            resolve(true);
          } 
        } else if (type == 'counts') {
          if (settingQtyLimiter.counts > settingQtyCurrent.count_count || settingQtyLimiter.counts == 0) {
            resolve(true);
          } 
        } else if (type == 'areas') {
          if (settingQtyLimiter.areas > settingQtyCurrent.area_count || settingQtyLimiter.areas == 0) {
            resolve(true);
          } 
        } else if (type == 'categories') {
          if (settingQtyLimiter.categories > settingQtyCurrent.category_count || settingQtyLimiter.categories == 0) {
            resolve(true);
          } 
        } else if (type == 'products') {
          if (settingQtyLimiter.products > settingQtyCurrent.product_count || settingQtyLimiter.products == 0) {
            resolve(true);
          } 
        } else if (type == 'locations') {
          if (settingQtyLimiter.locations > settingQtyCurrent.location_count || settingQtyLimiter.locations == 0) {
            resolve(true);
          } 
        }else{
          resolve(false);
        }
        resolve(false);
      });
    });
  }

  async onGetUserLimitCount(type) {
    return new Promise((resolve) => {
      this.store$.select(selectMeState).pipe(
        skipWhile(res => res == null),
      ).subscribe(({ settingQtyLimiter, settingQtyCurrent }) => {
        const limitDataCount$: any = {
          limit: 0,
          current: 0
        };
        if (type == 'users') {
          limitDataCount$.limit = settingQtyLimiter.users;
          limitDataCount$.current = settingQtyCurrent.user_count;
        } else if (type == 'counts') {
          limitDataCount$.limit = settingQtyLimiter.counts;
          limitDataCount$.current = settingQtyCurrent.count_count;
        } else if (type == 'areas') {
          limitDataCount$.limit = settingQtyLimiter.areas;
          limitDataCount$.current = settingQtyCurrent.area_count;
        } else if (type == 'categories') {
          limitDataCount$.limit = settingQtyLimiter.categories;
          limitDataCount$.current = settingQtyCurrent.category_count;
        } else if (type == 'products') {
          limitDataCount$.limit = settingQtyLimiter.products;
          limitDataCount$.current = settingQtyCurrent.product_count;
        } 
        resolve(limitDataCount$);
      });
    });
  }

}
